import { Injectable, EventEmitter } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { RequestResponse } from '../intefaces/requestResponse';
import { BehaviorSubject, Subscription } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class CurrencyService extends BaseService{

  currencyChangeEmitter = new EventEmitter();
  currencySubscription: Subscription;

  constructor(protected http: HttpClient) {
    super();
  }

  public onCurrencyEventEmitterClick(){
    this.currencyChangeEmitter.emit();
  }

  public getCurrencies(){
    return this.http.get<RequestResponse>(this.getUrl('allCurrencies'));
  }

  public getCurrency(code: string){
    let params = new HttpParams().set('code', code);
    return this.http.get<RequestResponse>(this.getUrl('currencyByCode'), {params: params});
  }

}
